// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "fb4fba0d2cab5a57db6ca64c8b616ccc" + ".js";
};